import React from 'react';
import {
  DataGrid,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbar,
  GridSearchIcon,
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridPageCountSelector,
  gridVisibleRowCountSelector
} from '@mui/x-data-grid';
import GridToolbarCustom from './GridToolbarCustom';
import useMain from 'hooks/useMain';
import { Checkbox, CircularProgress, Pagination, Stack, Typography, withStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { color } from '@mui/system';

import SortRoundedIcon from '@mui/icons-material/SortRounded';
import { makeStyles } from '@mui/styles';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

// const useStyles = makeStyles({
//   bgColor:{
//     backgroundColor: '#f3f6f5'
//   }
// });
const RevertSortRoundedIcon = () => <SortRoundedIcon sx={{ transform: 'rotate(180deg)' }} />;

const CusDataGrid = ({
  cusToolbarComponents,
  showExport,
  showToolbar = true,
  loading = false,
  custRowClass,
  showSearchBar,
  isBatchUpdate,
  ...rest
}) => {
  const { t } = useMain();
  const [pageSize, setPageSize] = React.useState(10);
  const theme = useTheme();
  const { onRowClick, rows } = rest;
  // const classes = useStyles();

  // custRowClass = (params)=>{
  //   return (params?.indexRelativeToCurrentPage)%2===1?classes.bgColor:'';
  // }

  if (loading) {
    return <CircularProgress />;
  }

  const CustomPagination = () => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const rowCount = useGridSelector(apiRef, gridVisibleRowCountSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    var currentPageRow = 0;

    if (rowCount > 0) {
      if (pageCount == 1) {
        currentPageRow = rowCount;
      } else if (page + 1 == pageCount) {
        if (rowCount % pageSize == 0) {
          currentPageRow = pageSize;
        } else {
          currentPageRow = rowCount % pageSize;
        }
      } else {
        currentPageRow = pageSize;
      }
    }

    return (
      <Stack flexDirection="row">
        {/* <Typography variant='body2' display='flex' alignItems='center'>顯示{page+1}項 , 共{pageCount * perPageRow}項</Typography>
         */}
        <Typography variant="body1" display="flex" alignItems="center" mr="8px">
          {t('PAGINGNATION', { PAGE: currentPageRow, TOTALPAGE: rowCount })}
        </Typography>
        <Pagination
          sx={{ backgroundColor: theme.palette.primary.lighter, borderRadius: '17px' }}
          shape="circular"
          color="primary"
          count={pageCount}
          page={page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      </Stack>
    );
  };

  // const CheckBoxWithStyles = withStyles({root:{
  //   color: 'red'
  // }})(Checkbox);

  const CustCheckBox = React.forwardRef((props, ref) => {
    return (
      <Checkbox
        icon={<RadioButtonUncheckedIcon />}
        checkedIcon={<CheckCircleIcon />}
        sx={{ color: theme.palette.primary[400] }}
        ref={ref}
        {...props}
      />
    );
  });
  return (
    // add theme color on bg
    <DataGrid
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      components={{
        Toolbar: showToolbar ? GridToolbarCustom : null,
        Pagination: CustomPagination,
        // ColumnSortedAscendingIcon: SortRoundedIcon,
        // ColumnSortedDescendingIcon: RevertSortRoundedIcon,
        // ColumnMenuIcon : SortRoundedIcon,
        BaseCheckbox: CustCheckBox
      }}
      componentsProps={{
        toolbar: {
          cusToolbarComponents,
          showExport,
          showSearchBar,
          isBatchUpdate
        }
      }}
      localeText={{
        toolbarExport: t('EXPORT')
      }}
      disableColumnFilter
      disableColumnSelector
      disableDensitySelector
      autoHeight
      sx={{
        '& .MuiDataGrid-columnHeaders': {
          height: 'auto',
          maxHeight: 'none !important',
          background: theme.palette.primary.lighter
        },
        '& .MuiDataGrid-cell': {
          overflowWrap: 'anywhere',
          whiteSpace: 'pre-wrap !important'
        },
        '& .MuiDataGrid-row': {
          cursor: onRowClick && 'pointer'
        },
        '& .MuiDataGrid-main': {
          borderRadius: '12px'
        }
      }}
      pagination
      rowsPerPageOptions={[10]}
      getRowClassName={custRowClass}
      // default height 52px
      // getRowHeight = {() => "auto"}
      // rowHeight={30}
      {...rest}
    />
  );
};

export default CusDataGrid;
